import { render, staticRenderFns } from "./PromocodesPage.vue?vue&type=template&id=17eeae72&scoped=true&"
import script from "./PromocodesPage.vue?vue&type=script&lang=js&"
export * from "./PromocodesPage.vue?vue&type=script&lang=js&"
import style0 from "./PromocodesPage.vue?vue&type=style&index=0&id=17eeae72&scoped=true&lang=scss&"
import style1 from "./PromocodesPage.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17eeae72",
  null
  
)

export default component.exports